<template>
  <LabelledInput
    label="Displayed Fields"
    helpful-tip="Choose the fields to display in the summary table by dragging items from the 'Unused Fields' list to the 'Summary Fields' list. You can re-order the Summary Fields."
  >
    <DraggableFields
      left-heading="Unused Fields"
      right-heading="Summary Fields"
      :source-fields.sync="numericMonetaryCalculationFields"
      :selected-columns.sync="summaryItems"
    />
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import DraggableFields from '@/components/common/DraggableFields/DraggableFields.vue'

import { SUMMARY_ITEMS_CONFIG_KEY } from '@/constants'

const components = {
  DraggableFields,
  LabelledInput,
}

@Component({ components })
export default class SelectFields extends Vue {
  get numericMonetaryCalculationFields () {
    return this.$typedStore.visualisationApp.numericMonetaryCalculationFields
  }

  get summaryItems () {
    return this.$typedStore.primary.app.config[SUMMARY_ITEMS_CONFIG_KEY]
  }

  set summaryItems (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SUMMARY_ITEMS_CONFIG_KEY],
      value,
    })
  }
}

</script>
